import { render, staticRenderFns } from "./addUsdtCard.vue?vue&type=template&id=bd609288&scoped=true"
import script from "./addUsdtCard.vue?vue&type=script&lang=js"
export * from "./addUsdtCard.vue?vue&type=script&lang=js"
import style0 from "./addUsdtCard.vue?vue&type=style&index=0&id=bd609288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd609288",
  null
  
)

export default component.exports